import React, { PropTypes, PureComponent } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { decamelizeKeys } from 'humps';
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { createValidator, required, match } from '../../components/Form/validators';
import { callApi } from '../../middleware/api';
import { Input } from '../../components/Form';
import { logInFromResponse } from '../../redux/actions';
import Loader from '../../components/Loader';
import Alert from '../../components/Form/Alert';


class From extends PureComponent {
  render() {
    const { handleSubmit, invalid, error, submitting } = this.props;
    return (
      <form className="mt-3 col-lg-7" onSubmit={handleSubmit} noValidate>
        {error && <Alert>{error}</Alert>}
        <Field component={Input} type="password" name="password" label="Parole" />
        <Field component={Input} type="password" name="passwordConfirm" label="Parole atkāroti" />
        <button 
          className="btn pull-right btn-primary btn-lg"
          disabled={invalid || submitting }
          type="submit"
        >
          Iestatīt
        </button>
    </form>
    );
  }
}

const validate = createValidator({
  password: [required],
  passwordConfirm: [required, match('password')]
});

const SetPasswordForm = reduxForm({
  form: 'set_password',
  validate,
})(From);


class Confirm extends PureComponent {
  static propTypes = {
    logInFromResponse: PropTypes.func.isRequired
  };

  static contextTypes = {
    user: PropTypes.object,
    company: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      valid: null,
      success: false
    };

    this.handleSubmit = this.handleSubmit.bind(this)
  };

  componentDidMount() {
    const {match: {params: {uid, token}}} = this.props;
    return callApi(`reset/confirm/${uid}/${token}/`, undefined, "GET").then(
      resp => this.setState({valid: true}),
      ({response, json}) => this.setState({valid: false})
    );    
  }

  handleSubmit(values) {
    const {match: {params: {uid, token}}, logInFromResponse} = this.props;
    return callApi(`reset/confirm/${uid}/${token}/`, undefined, "POST", decamelizeKeys(values)).then(
      resp => {
        logInFromResponse(resp).then(payload => this.setState({success: true}));
      },
      ({response, json}) => {
        if (response.status === 404)  {
          this.setState({valid: false});
        } else {
          const { nonFieldErrors: _error, ...errors } = json;
          throw new SubmissionError({...errors, _error});
        }
      }
    );
  };

  render() {
    const { valid, success } = this.state;
    const { user, company } = this.context;

    if (success) {
      if (user && company && !user.isConfirmed) {
        return (
          <div className="container mt-5">
            <Alert label="Paldies, ka reģistrējāties!" type="success">
              <p>Tuvākajā laikā izskatīsim Jūsu pieteikumu lai pievienotu Jūsu lietotāju uzņēmumam SIA "{company.name}".</p>
              <p>Par pieteikuma rezultātu informēsim Jūs atsevišķā e-pastā.</p>
            </Alert>
          </div>
        )
      }

      return <Redirect to="/"/>
    }

    return (
      <div className="container mt-5">
        <h1 className="mb-5">Iestatīt paroli</h1>
        <Loader loaded={valid !== null}>
          {valid
              ? (<div className="row">
                  <SetPasswordForm onSubmit={this.handleSubmit} />
                </div>)
              : <Alert>Šī saite nav valīda</Alert>
          }
        </Loader>
      </div>
    );
  }
};

export default connect(null, { logInFromResponse })(Confirm);


// WEBPACK FOOTER //
// ./src/scenes/Reset/Confirm.js